/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    iosConfigList: [],
    androidConfigList: [],
    h5ConfigList: [],
    windowsConfigList: [],
    iosPackageList: [],
    androidPackageList: [],
    h5PackageList: [],
    windowsPackageList: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_TOKEN_LIST ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/adjust-tokens', {platform: args.platform}).then(
            function (res) {
                data = res.data.tokens;
                for (let i in data) {
                    if (data[i]['token_type'] === 0) {
                        data[i]['token_type_name'] = 'Adjust Token';
                    }
                    else if (data[i]['token_type'] === 1) {
                        data[i]['token_type_name'] = 'Admob Token';
                    }
                    else if (data[i]['token_type'] === 2) {
                        data[i]['token_type_name'] = 'Google Ads';
                    }
                    else if (data[i]['token_type'] === 3) {
                        data[i]['token_type_name'] = 'Applovin Token';
                    }
                }
                if (args.platform === 'IOS') {
                    commit('_iosConfigList', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5ConfigList', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsConfigList', data);
                }
                else {
                    commit('_androidCongfigList', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    PUT_TOKEN_EDIT ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        commit('PRIVATE_LOADING', true, {root: true});
        rootState.$helper.request.put('/games/' + gameCode + '/adjust-tokens/' + args.token_id, args).then(
            function (res) {
                data = res.data.edited;
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '编辑成功!',
                        callback () {
                            rootState.$helper.helper.route('sdk/adjusttoken', {platform: data.platform.toUpperCase()});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '编辑失败!',
                        callback () {
                            rootState.$helper.helper.route('sdk/adjusttoken');
                        }
                    }, {
                        root: true
                    });
                }
                commit('PRIVATE_LOADING', false, {root: true});
            }
        ).catch(function (error) {
            commit('PRIVATE_LOADING', false, {root: true});
            let message = '操作失败！';
            if (error['response'] &&
                error['response']['data'] &&
                error['response']['data']['exception'] &&
                error['response']['data']['exception']['message']
            ) {
                message = error['response']['data']['exception']['message'];
            }
            dispatch('ALERT_HANDLE', {message: message, reload: true}, {root: true});
        });
    },
    PUT_TOKEN_NEW ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        commit('PRIVATE_LOADING', true, {root: true});
        rootState.$helper.request.put('/games/' + gameCode + '/adjust-tokens/newbatch', {adjust_arg: args}).then(
            function (res) {
                data = res.data.batchadd[0]['created'];
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '添加成功!',
                        callback () {
                            /*
                            dispatch('GET_TOKEN_LIST', {
                                platform: data.platform
                            });
                            */
                            rootState.$helper.helper.route('sdk/adjusttoken', {platform: data.platform.toUpperCase()});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '添加失败!',
                        callback () {
                            dispatch('GET_TOKEN_LIST', {platform: data.platform.toUpperCase()});
                        }
                    }, {root: true});
                }
                commit('PRIVATE_LOADING', false, {root: true});
            }
        ).catch(function (error) {
            commit('PRIVATE_LOADING', false, {root: true});
            let message = '操作失败！';
            if (error['response'] &&
                error['response']['data'] &&
                error['response']['data']['exception'] &&
                error['response']['data']['exception']['message']
            ) {
                message = error['response']['data']['exception']['message'];
            }
            dispatch('ALERT_HANDLE', {message: message, reload: true}, {root: true});
        });
    },
    GET_PACKAGE_LIST ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getpackagenamelist', {
            game_code: gameCode,
            platform: args.platform
        }).then(
          function (res) {
              data = res.data.result;
              if (args.platform === 'IOS') {
                  commit('_iosPackageList', data);
              }
              else if (args.platform === 'H5') {
                  commit('_h5PackageList', data);
              }
              else if (args.platform === 'WINDOWS') {
                  commit('_windowsPackageList', data);
              }
              else {
                  commit('_androidPackageList', data);
              }
          }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    TOKEN_ENABLED ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/adjust-tokens/' + args.token_id,
            {
                enabled: args.enabled
            }).then(
            function (res) {
                data = res.data.result;
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    DELETE_ROW ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.delete('/games/' + gameCode + '/adjust-tokens/' + args.token_id, {platform: args.platform}).then(
            function (res) {
                data = res.data.deleted;
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '删除成功!',
                        callback () {
                            rootState.$helper.helper.route('sdk/adjusttoken', {platform: args.platform});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '删除失败!',
                        callback () {
                            dispatch('GET_TOKEN_LIST', {platform: args.platform});
                        }
                    }, {root: true});
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _iosConfigList (state, args) {
        state.iosConfigList = args;
        console.log('_iosConfigList=', state.iosConfigList);
    },
    _androidCongfigList (state, args) {
        state.androidConfigList = args;
        console.log('_androidCongfigList=', state.androidConfigList);
    },
    _h5ConfigList (state, args) {
        state.h5ConfigList = args;
        console.log('_h5CongfigList=', state.h5ConfigList);
    },
    _windowsConfigList (state, args) {
        state.windowsConfigList = args;
        console.log('_windowsCongfigList=', state.windowsConfigList);
    },
    _iosPackageList (state, args) {
        state.iosPackageList = args;
        console.log('_iosPackageList=', state.iosPackageList);
    },
    _androidPackageList (state, args) {
        state.androidPackageList = args;
        console.log('_androidPackageList=', state.androidPackageList);
    },
    _h5PackageList (state, args) {
        state.h5PackageList = args;
        console.log('_h5PackageList=', state.h5PackageList);
    },
    _windowsPackageList (state, args) {
        state.windowsPackageList = args;
        console.log('_windowsPackageList=', state.windowsPackageList);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/sdk/adjustToken.js